import React from "react";
import InView from "../../misc/InView";
import { EqualHeight } from "react-equal-height";
import PlayCard from "../cards/PlayCard";
import { Grid } from "@material-ui/core";
import { v4 as uuidv4 } from "uuid";


const ArtistSimilars = ({ similars }) => {
  return (
    <InView>
      <h2 className="pt-5">Related Artists</h2>

      <EqualHeight>
        <Grid container className="card-container pt-3" spacing={2}>
          {similars.map(
            ({
              musicPath,
              artistDefaultImage,
              artistName,
              _artistId,
              station_id,
            }) => {
              return (
                <Grid key={uuidv4()} item xs={6} md={3} lg={2}>
                  <PlayCard
                    title={artistName}
                    image={artistDefaultImage}
                    musicPath={musicPath}
                    station_id={station_id}
                  />
                </Grid>
              );
            }
          )}
        </Grid>
      </EqualHeight>
    </InView>
  );
};

export default ArtistSimilars;